<template>
  <div class="h7-text text-right next-step">
    {{ info.steps && info.steps[step_num] ?
      `${$t('Catalog.Step')} ${step || step_num + 1}` : '' }}
    {{ bigFirstLetter ( name ? name : $t('Tenders.' + step_name ) ) }}
    <sIcon
      class="ml-1"
      color="grey"
      rotate="-90"
      size="12"
      type="long-arrow"/>
  </div>
</template>
<script>
import { modalMixin, tenderMixin } from 'mixins'

export default {
  name: 'nextStep',
  mixins: [ tenderMixin, modalMixin ],
  props: {
    step: [Number, String],
    name: String
  },
  computed: {
    info() {
      return this.$store.getters['getNewTenderInfo']
    },
    step_num() {
      return this.info.step || 1
    },
    step_name() {
      return this.info?.steps?.length ? this.info?.steps[this.step_num ] || 'Publishing' : ''
    }
  }
}
</script>
